module.exports = __webpack_public_path__ + "static/media/data.cf3766d9.svg";